/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import Modal from 'react-modal'
import Loader from '../../../common/loader/legacy-loaders/Op36Loader-web'
import StudentPreviewCard from '../../../common/StudentPreviewCard'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'
import * as goalActions from '../../../../actions/goalActions'

class AddStudentsModal extends Component {
  state = {
    selectedStudents: [],
  }

  filterStudents = id => {
    const selectedStudents = [...this.state.selectedStudents]

    const index = selectedStudents.indexOf(id)

    if (index > -1) {
      selectedStudents.splice(index, 1)
    } else if (index === -1) {
      selectedStudents.push(id)
    }

    this.setState({ selectedStudents })
  }

  assignStudents = () => {
    const selectedStudents = [...this.state.selectedStudents]
    const { closeModal, goal_actions, goal, getActiveStudents } = this.props

    goal_actions.createGoalsFromTemplate(goal, selectedStudents).then(() => {
      getActiveStudents(goal)
    })
    this.setState({ selectedStudents: [] }, () => closeModal())
  }

  renderStudents = (students, loading) => {
    const { t } = this.props
    if (loading || !students) {
      return <Loader message={t('profile.goals.addStudents.loadingStudents')} />
    }
    if (students.length === 0) {
      return <p>{t('profile.goals.addStudents.noStudents')}</p>
    }
    const selectedStudents = [...this.state.selectedStudents]
    return students.map(student => (
      <StudentPreviewCard
        student={student}
        key={student.id}
        filterStudents={this.filterStudents}
        selectedStudents={selectedStudents}
      />
    ))
  }

  render() {
    const { showModal, closeModal, students, loading, t } = this.props
    const { selectedStudents } = this.state
    return (
      <Modal
        isOpen={showModal}
        onRequestClose={closeModal}
        contentLabel={t('profile.goals.addStudents.goalModal')}
      >
        <div className='modal-header row'>
          <div className='col-10'>
            <h5 className='modal-title display-4 uppercase detail-title'>
              {t('profile.goals.addStudents.addStudents')}
            </h5>
          </div>
          <div className='col-2'>
            <button
              type='button'
              className='close pull-right font-200 modal-close-btn'
              data-dismiss='modal'
              aria-label={t('common.close')}
              onClick={closeModal}
            >
              <span aria-hidden='true'>✕</span>
            </button>
          </div>
        </div>
        <div className='row w-50 mx-auto mt-3'>
          {this.renderStudents(students, loading)}
        </div>
        {!loading && (
          <div className='row bg-white pb-3 mt-5 animated fadeIn'>
            <div className='col-6 mx-auto'>
              <div className='row'>
                <div className='col-md-6'>
                  <button className='btn w-100 btn-dark' onClick={closeModal}>
                    {t('common.cancel')}
                  </button>
                </div>
                <div className='col-md-6'>
                  <button
                    className='btn btn-block btn-primary'
                    disabled={selectedStudents.length === 0}
                    onClick={this.assignStudents}
                  >
                    {t('profile.goals.addStudents.assignStudents')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    goal_actions: bindActionCreators(goalActions, dispatch),
  }
}

export default connect(
  null,
  mapDispatchToProps
)(withTranslation()(AddStudentsModal))
